<template>
    <div class="work-nav">
        <span v-for="(item, index) in navigator" :key="index" :class="{ 'active': active === index }"
            @click="changeTab(index)">{{ item.name }}({{ item.number }})</span>
        <el-button size="mini" plain v-if="active === 2" v-clipboard:copy="copyText"
            v-clipboard:success="onCopy">复制名单</el-button>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
    components: { Clipboard },
    data () {
        return {
            active: 0,
            navigator: [
                {
                    id: 1,
                    name: '未批改',
                    number: 0
                },
                {
                    id: 2,
                    name: '已批改',
                    number: 0
                },
                {
                    id: 3,
                    name: '未反馈',
                    number: 0
                },
            ],
            copyText: '',
        }
    },

    props: {
        number1: {
            type: Number,
            default: 0
        },
        number2: {
            type: Number,
            default: 0
        },
        number3: {
            type: Number,
            default: 0
        },
        copyData: {
            type: Array,
        }
    },

    watch: {
        number1 (val) {
            this.number1 = val
            this.updateCorrectNum()
        },
        number2 (val) {
            this.number2 = val
            this.updateCorrectNum()
        },
        number3 (val) {
            this.number3 = val
            this.updateCorrectNum()
        }
    },

    mounted () {
        this.updateCorrectNum()
        if (this.copyData.length) {
            const copyArray = this.copyData.map(item => {
                return item.name
            })
            this.copyText = copyArray.join(' ')
        }


        this.$emit('changeTab', this.active)
    },

    methods: {
        changeTab (index) {
            this.active = index
            this.$emit('changeTab', index)
        },
        // 复制名单
        onCopy () {
            this.$message.success('复制成功')
        },
        // 更新批改数量
        updateCorrectNum () {
            this.$set(this.navigator[0], 'number', this.number1)
            this.$set(this.navigator[1], 'number', this.number2)
            this.$set(this.navigator[2], 'number', this.number3)
        }
    }

}
</script>

<style lang="scss" scoped>
.work-nav {
    // height: 70px;
    // line-height: 70px;
    border-bottom: 1px solid #D8E2EB;
    ;

    .active {
        color: #1B2422;
        font-weight: bold;

        &::after {
            position: absolute;
            right: 0;
            bottom: 0;
            content: '';
            width: 100%;
            height: 2px;
            background: #2881CD;
        }
    }

    span {
        position: relative;
        margin: 0 24px;
        display: inline-block;
        height: 70px;
        line-height: 70px;
        cursor: pointer;
        // &::after {
        //     position: absolute;
        //     right: 0;
        //     bottom: 0;
        //     content: '';
        //     width: 100%;
        //     height: 2px;
        //     background: #2881CD;
        // }
    }

    .el-button {
        float: right;
        margin-top: 20px;
        margin-right: 20px;
        color: #007AFF;
        background: #EBF6FF;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/teacher/WorkNav.vue